<template>
  <div class="org-settings-ts__toggle-row">
    <div class="org-settings-ts__toggle-copy">
      <span class="org-settings-ts__toggle-label">{{ label }}</span>
      <span v-if="hint" class="org-settings-ts__toggle-hint">{{ hint }}</span>
    </div>
    <button
      type="button"
      class="org-settings-twf__switch"
      :class="{ 'org-settings-twf__switch--on': modelValue }"
      role="switch"
      :aria-checked="!!modelValue"
      :aria-label="label"
      @click="$emit('update:modelValue', !modelValue)"
    >
      <span class="org-settings-twf__switch-thumb" />
    </button>
  </div>
</template>

<script>
export default {
  name: "OrgSettingsToggleRow",
  props: {
    modelValue: { type: Boolean, default: false },
    label: { type: String, required: true },
    hint: { type: String, default: "" },
  },
  emits: ["update:modelValue"],
};
</script>
